import { graphql } from 'gatsby';
import React from 'react';
import { Helmet } from 'react-helmet';
import config from '../../data/SiteConfig';
import SEO from '../components/SEO/SEO';
import Navbar from '../components/Navbar/Navbar';
import Layout from '../components/Layout';

export default function brand({ data, pageContext }) {
  const { slug } = pageContext;

  const navData = data.devices.edges.map((typeEdge) => ({
    title: typeEdge.node.frontmatter.title,
    slug: `${slug}/${typeEdge.node.frontmatter.slug}`,
  }));
  const brandNode = data.brand;
  const post = brandNode.frontmatter;
  if (!post.id) {
    post.id = slug;
  }

  return (
    <Layout color={post.color}>
      <Navbar navData={navData} />

      <div>
        <Helmet>
          <title>{`${post.title} | ${config.siteTitle}`}</title>
        </Helmet>
        <SEO postPath={slug} postNode={brandNode} postSEO />
        <div>
          <h1>{post.title}</h1>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: brandNode.html }} />
        </div>
      </div>
    </Layout>
  );
}
export const pageQuery = graphql`
  query($slug: String!) {
    brand: markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      timeToRead
      excerpt
      frontmatter {
        title
        slug
        cover {
          publicURL
        }
        color
      }
      fields {
        slug
      }
    }
    devices: allMarkdownRemark(
      filter: { frontmatter: { brand: { eq: $slug } } }
    ) {
      edges {
        node {
          frontmatter {
            brand
            title
            slug
          }
        }
      }
    }
  }
`;
